var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tixstock-search-skeleton"},[_c('div',{staticClass:"tixstock-search-box-skeleton"},[_c('div',{staticClass:"search-icon-skeleton"}),_c('div',{staticClass:"search-input-skeleton"})])])])
}]

export { render, staticRenderFns }